import React from 'react';
import { MapPin, Phone } from 'lucide-react';

const Hero = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative bg-gradient-to-br from-yellow-300 via-yellow-400 to-amber-400 min-h-[80vh] flex items-center overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-10 left-10 w-32 h-32 bg-blue-400 rounded-full mix-blend-multiply filter blur-xl animate-pulse"></div>
        <div className="absolute top-40 right-20 w-24 h-24 bg-blue-500 rounded-full mix-blend-multiply filter blur-xl animate-pulse animation-delay-2000"></div>
        <div className="absolute bottom-20 left-1/4 w-40 h-40 bg-blue-600 rounded-full mix-blend-multiply filter blur-xl animate-pulse animation-delay-4000"></div>
      </div>
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Content */}
          <div className="text-center lg:text-left">
            <h1 className="text-5xl md:text-6xl font-bold text-gray-900 mb-6 leading-tight">
              Authentic Filipino <br />
              <span className="text-gray-800">Lumpia Rolls</span>
            </h1>
            
            <p className="text-xl text-gray-800 mb-8 leading-relaxed">
              Come get your good vibes and extra crispy rolls
            </p>
            
            {/* Quick Info */}
            <div className="flex flex-col sm:flex-row gap-4 mb-8 justify-center lg:justify-start">
              <div className="flex items-center justify-center lg:justify-start space-x-2 text-gray-800">
                <MapPin className="h-5 w-5" />
                <span className="font-medium">El Mirage, AZ</span>
              </div>
              <div className="flex items-center justify-center lg:justify-start space-x-2 text-gray-800">
                <Phone className="h-5 w-5" />
                <span className="font-medium">(480) 744-9683</span>
              </div>
            </div>
            
            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
              <button 
                onClick={() => scrollToSection('menu')}
                className="bg-gray-900 text-yellow-100 px-8 py-4 rounded-lg text-lg font-semibold hover:bg-gray-800 transform hover:scale-105 transition-all duration-200 shadow-lg"
              >
                View Menu
              </button>
              <button 
                onClick={() => scrollToSection('contact')}
                className="bg-white text-gray-900 px-8 py-4 rounded-lg text-lg font-semibold hover:bg-gray-50 transform hover:scale-105 transition-all duration-200 shadow-lg border-2 border-gray-900"
              >
                Order Now
              </button>
            </div>
          </div>
          
          {/* Hero Image */}
          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl transform hover:scale-105 transition-transform duration-300">
              <img 
                src="https://customer-assets.emergentagent.com/job_flavor-rolls/artifacts/09tli7zx_IMG_3971.jpeg" 
                alt="Roll Up Lumpia Co. - Authentic Filipino Lumpia" 
                className="w-full h-96 object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-gray-900/20 to-transparent"></div>
            </div>
            
            {/* Floating Badge */}
            <div className="absolute -top-4 -right-4 bg-white rounded-full p-4 shadow-xl border-4 border-yellow-400">
              <img 
                src="https://customer-assets.emergentagent.com/job_flavor-rolls/artifacts/09tli7zx_IMG_3971.jpeg" 
                alt="Roll Up Lumpia Co." 
                className="w-16 h-16 rounded-full"
              />
            </div>
          </div>
        </div>
        
        {/* Scroll Indicator */}
        <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
          <div className="w-6 h-10 border-2 border-gray-900 rounded-full flex justify-center">
            <div className="w-1 h-3 bg-gray-900 rounded-full mt-2 animate-pulse"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;